import { ChangeDetectionStrategy, Component} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Constants } from '../../../common/helper/Constants';
import { RouterLink } from '@angular/router';
import { PermissionDirective } from "../../auth/permission.directive";
import { Role } from '../../auth/role.enum';

@Component({
  selector: 'gate-external-portals',
  standalone: true,
  imports: [TranslatePipe, RouterLink, PermissionDirective],
  templateUrl: './external-portals.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExternalPortalsComponent{
  public routes = Constants.routes;
  public role = Role;
}
